<div class="pageheader">
  <div class="page-title">
    <h1>User roles</h1>
    <div class="btn-group" data-toggle="buttons">
      <button class="btn btn-link" id="btnNew" *bizPermissionRequired="'UserRoles_Action_Create'" (click)="createNew()">Create new <ep-svg-icon icon="plus"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'UserRole_Action_ShowLog'" [title]="'User roles log'">
        <app-change-log-link-entity type="Role"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<div class="btn-toolbar form-group">
  <div class="btn-group">
    <button id="showRoleButton" class="btn btn-primary btn-sm" *bizPermissionRequired="'UserRoles_Action_Edit'" [disabled]="!selectedRow"
    (click)="showRole(this.selectedRow)">Show role details</button>
  </div>
</div>

<dx-data-grid biz-grid
  [selection]='{ mode: "single" }'
  [dataSource]='roles'
    [masterDetail]="{
        enabled: true,
        template: 'permissionsMasterTemplate'
    }"
  [bizAutoWidth]="false"
  (onSelectionChanged)='selectionChanged($event)'>

  <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

  <!-- Shared columns -->
  <dxi-column dataField="RoleName" caption="Name" width="300" dataType="string" [validationRules]="[{ type: 'required' }]"></dxi-column>
  <dxi-column #columnPermissions
    dataField="Permissions"
    caption="Permissions"
    cellTemplate="permissionsTemplate"
    [calculateFilterExpression]="calculateArrayFilterExpression"
    [calculateSortValue]="calculateSortValue">
    <dxo-header-filter [dataSource]="getPermissionsHeaderFilterData()"></dxo-header-filter>
  </dxi-column>

  <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
    <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(roles, 'CreatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
  <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
    <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(roles, 'UpdatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

  <dxi-column type="buttons">
    <dxi-button text="Show Log"
      template="logTemplate"
      [visible]="showLogAllowed">
    </dxi-button>
  </dxi-column>

  <ng-container *dxTemplate="let cell of 'logTemplate'">
    <app-change-log-link *bizPermissionRequired="'UserRole_Action_ShowLog'" [title]="'Log for ' + cell.data.RoleName" [showIcon]="false" classNames="dx-link">
      <app-change-log-link-entity type="Role" [id]="cell.data.RoleId"></app-change-log-link-entity>
    </app-change-log-link>
  </ng-container>

  <div *dxTemplate="let cell of 'permissionsMasterTemplate'">
    <div>
      <label>Permissions:</label>
      <dx-data-grid [dataSource]='cell.data.Permissions' [columnAutoWidth]='true'>
        <dxi-column dataField="PermissionName" caption="Permission" dataType="string" sortOrder="asc"></dxi-column>
        <dxi-column dataField="Description" caption="Description" dataType="string"></dxi-column>
      </dx-data-grid>
    </div>
  </div>


  <div *dxTemplate="let cell of 'permissionsTemplate'">
    @for (permission of cell.data.Permissions; track permission; let isLast = $last) {
      <span>{{permission.PermissionName}}{{isLast ? '' : ', '}}</span>
    }
  </div>
</dx-data-grid>
